import React, { useState } from "react";
import avankart from "../assets/images/avankart.png";
import testup from "../assets/images/testup.png";
import rrgroup from "../assets/images/rrgroup.png";
import industry4 from "../assets/images/industry4.png";
import fanus from "../assets/images/fanus.png";
import ces from "../assets/images/ces.png";
import "../assets/styles/Project.scss";

const PROJECTS = [
  {
    name: "Construction Equipment Services",
    role: "Head of Product",
    href: "https://ces.com.az/",
    domain: "ces.com.az",
    img: ces,
    desc: "Şirkətin vebsayt layihəsində məhsul strategiyasını və yol xəritəsini qurmuş, komanda formalaşdıraraq layihəni sıfırdan bazara çıxarmışam.",
  },
  {
    name: "fanusopc.com",
    role: "Product Owner",
    href: "https://fanusopc.com/",
    domain: "fanusopc.com",
    img: fanus,
    desc: "Onlayn psixoloji dəstək platformasının məhsul vizyonunu formalaşdırmış, təsdiqlənmiş psixoloqlara müraciət və seans rezervasiyası funksionallıqlarını komandayla birgə həyata keçirmişəm.",
  },
  {
    name: "testup.az",
    role: "Product Owner",
    href: "https://testup.az/",
    domain: "testup.az",
    img: testup,
    desc: "Məhsulun vizyonunu və funksionallıqlarını müəyyən etmiş, komandanı idarə etmişəm. Layihənin büdcə və vaxt çərçivəsini uğurla idarə etmişəm.",
  },
  {
    name: "avankart.az",
    role: "IT Project Manager",
    href: "https://avankart.az/",
    domain: "avankart.az",
    img: avankart,
    desc: "Backend komandasına rəhbərlik etməklə layihənin planlaşdırılması və idarə edilməsi ilə məşğul olmuşam, digər komandalarla sıx əməkdaşlıq qurmuşam.",
  },
  {
    name: "industry4.az",
    role: "IT Biznes Analitik",
    href: "https://www.industry4.az/",
    domain: "industry4.az",
    img: industry4,
    desc: "Şirkətlərin müraciətlərini qəbul edən sistem və müraciətlərin rol əsasında idarə olunması üçün admin panel qurmuşam.",
  },
  {
    name: "rrgroup.az",
    role: "Product Owner",
    href: "https://rrgroup.az/",
    domain: "rrgroup.az",
    img: rrgroup,
    desc: "Müştəri tələblərini əsas alaraq məhsulun vizyonunu formalaşdırmış, köhnə dizaynı uğurla yeniləyərək məhsulu təhvil vermişəm.",
  },
];

function Project() {
  const [active, setActive] = useState(0);
  const p = PROJECTS[active];

  return (
    <section id="projects" className="projects">
      <div className="sec-head" data-reveal>
        <span className="sec-num" aria-hidden="true">
          02
        </span>
        <h2 className="sec-title">İştirak Etdiyim Layihələr</h2>
      </div>

      <div className="proj-body" data-reveal>
        <div className="proj-list">
          {PROJECTS.map((item, i) => (
            <div
              key={item.name}
              className={`proj-row ${i === active ? "active" : ""}`}
              role="button"
              tabIndex={0}
              onClick={() => setActive(i)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  setActive(i);
                }
              }}
            >
              <span className="proj-idx">0{i + 1}</span>
              <span className="proj-name">{item.name}</span>
              <span className="proj-arrow" aria-hidden="true">
                →
              </span>
            </div>
          ))}
        </div>

        <div className="proj-preview">
          <div className="proj-preview-inner">
            <div className="proj-img">
              <img src={p.img} alt={p.name} />
            </div>
            <div className="proj-meta">
              <span className="proj-role">{p.role}</span>
              <a
                href={p.href}
                target="_blank"
                rel="noreferrer"
                className="proj-link"
              >
                {p.domain} ↗
              </a>
            </div>
            <p className="proj-desc">{p.desc}</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Project;
